import React from 'react';
import { Route } from 'react-router-dom';
import LegisClubFuels from './legisClubFuels';

export default (
  <Route path="legisclub-gasolina">
    <Route component={(props) => <LegisClubFuels {...props} />} />
  </Route>
);
